<template>
    <div class="case_detial" v-loading="loading">
        <div class="case_detial_box">

            <div class="top_box">
                <img src="@/assets/img/login/Frame.png" alt="">
                <span class="span1" @click="handle_home">首页</span>
                > 法律课堂 >详情
            </div>
            <div class="detial_flex">
                <div class="inof_box" :class="{inof_box_show:is_show}">
                    <div class="info_pay_btns" v-if="is_show">
                        <div class="info_pay_btns_top"></div>
                        <div class="info_pay_btns_bom">
                            <div class="btns_pay" @click="handle_pay">
                                付费查看
                            </div>
                        </div>
                    </div>
                    <div class="info_1">
                        <div class="title_flex">
                            {{ nwe_detial.title ||''}}
                        </div>
                        <div class="tage_info">
                            <div class="tage_flex">
                                <div class="tege_title">时间：</div>
                                <div class="tege_text">     
                                    {{ nwe_detial.pub_time ||''}}
                                </div>
                            </div>
                            <div class="borders"></div>
                            <div class="tage_flex">
                                <div class="tege_title">{{nwe_detial.cateid_txt}}</div>
                            </div>
                        </div>
                        <div class="btns_flex">
                           
                        </div>
                        <div class="const_box">
                          
                            <div class="const_const" v-html="nwe_detial.content">
                                <!-- 原告上海中原物业顾问有限公司（简称中原公司）诉称：被告陶德华利用中原公司提供的上海市虹口区株洲路某号房屋销售信息，故意跳过中介，私自与卖方直接签订购房合同，违反了《房地产求购确认书》的约定，属于恶意“跳单”行为，请求法院判令陶德华按约支付中原公司违约金1.65万元。
                                被告陶德华辩称：涉案房屋原产权人李某某委托多家中介公司出售房屋，中原公司并非独家掌握该房源信息，也非独家代理销售。陶德华并没有利用中原公司提供的信息，不存在“跳单”违约行为。
                                法院经审理查明：2008年下半年，原产权人李某某到多家房屋中介公司挂牌销售涉案房屋。2008年10月22日，上海某房地产经纪有限公司带陶德华看了该房屋；11月23日，上海某房地产顾问有限公司(简称某房地产顾问公司)带陶德华之妻曹某某看了该房屋；11月27日，中原公司带陶德华看了该房屋，并于同日与陶德华签订了《房地产求购确认书》。该《确认书》第2.4条约定，陶德华在验看过该房地产后六个月内，陶德华或其委托人、代理人、代表人、承办人等与陶德华有关联的人，利用中原公司提供的信息、机会等条件但未通过中原公司而与第三方达成买卖交易的，陶德华应按照与出卖方就该房地产买卖达成的实际成交价的1%，向中原公司支付违约金。当时中原公司对该房屋报价165万元，而某房地产顾问公司报价145万元，并积极与卖方协商价格。11月30日，在某房地产顾问公司居间下，陶德华与卖方签订了房屋买卖合同，成交价138万元。后买卖双方办理了过户手续，陶德华向某房地产顾问公司支付佣金1. 38万元。
                                原告上海中原物业顾问有限公司（简称中原公司）诉称：被告陶德华利用中原公司提供的上海市虹口区株洲路某号房屋销售信息，故意跳过中介，私自与卖方直接签订购房合同，违反了《房地产求购确认书》的约定，属于恶意“跳单”行为，请求法院判令陶德华按约支付中原公司违约金1.65万元。
                                被告陶德华辩称：涉案房屋原产权人李某某委托多家中介公司出售房屋，中原公司并非独家掌握该房源信息，也非独家代理销售。陶德华并没有利用中原公司提供的信息，不存在“跳单”违约行为。
                                法院经审理查明：2008年下半年，原产权人李某某到多家房屋中介公司挂牌销售涉案房屋。2008年10月22日，上海某房地产经纪有限公司带陶德华看了该房屋；11月23日，上海某房地产顾问有限公司(简称某房地产顾问公司)带陶德华之妻曹某某看了该房屋；11月27日，中原公司带陶德华看了该房屋，并于同日与陶德华签订了《房地产求购确认书》。该《确认书》第2.4条约定，陶德华在验看过该房地产后六个月内，陶德华或其委托人、代理人、代表人、承办人等与陶德华有关联的人，利用中原公司提供的信息、机会等条件但未通过中原公司而与第三方达成买卖交易的，陶德华应按照与出卖方就该房地产买卖达成的实际成交价的1%，向中原公司支付违约金。当时中原公司对该房屋报价165万元，而某房地产顾问公司报价145万元，并积极与卖方协商价格。11月30日，在某房地产顾问公司居间下，陶德华与卖方签订了房屋买卖合同，成交价138万元。后买卖双方办理了过户手续，陶德华向某房地产顾问公司支付佣金1. 38万元。
                                原告上海中原物业顾问有限公司（简称中原公司）诉称：被告陶德华利用中原公司提供的上海市虹口区株洲路某号房屋销售信息，故意跳过中介，私自与卖方直接签订购房合同，违反了《房地产求购确认书》的约定，属于恶意“跳单”行为，请求法院判令陶德华按约支付中原公司违约金1.65万元。
                                被告陶德华辩称：涉案房屋原产权人李某某委托多家中介公司出售房屋，中原公司并非独家掌握该房源信息，也非独家代理销售。陶德华并没有利用中原公司提供的信息，不存在“跳单”违约行为。
                                法院经审理查明：2008年下半年，原产权人李某某到多家房屋中介公司挂牌销售涉案房屋。2008年10月22日，上海某房地产经纪有限公司带陶德华看了该房屋；11月23日，上海某房地产顾问有限公司(简称某房地产顾问公司)带陶德华之妻曹某某看了该房屋；11月27日，中原公司带陶德华看了该房屋，并于同日与陶德华签订了《房地产求购确认书》。该《确认书》第2.4条约定，陶德华在验看过该房地产后六个月内，陶德华或其委托人、代理人、代表人、承办人等与陶德华有关联的人，利用中原公司提供的信息、机会等条件但未通过中原公司而与第三方达成买卖交易的，陶德华应按照与出卖方就该房地产买卖达成的实际成交价的1%，向中原公司支付违约金。当时中原公司对该房屋报价165万元，而某房地产顾问公司报价145万元，并积极与卖方协商价格。11月30日，在某房地产顾问公司居间下，陶德华与卖方签订了房屋买卖合同，成交价138万元。后买卖双方办理了过户手续，陶德华向某房地产顾问公司支付佣金1. 38万元。
                                在某房地产顾问公司居间下，陶德华与卖方签订了房屋买卖合同，成交价138万元。后买卖双方办理了过户手续，陶德华向某房地产顾问公司支付。 -->
                            </div>
                             <div class="pl_bq">
                                版权申明：对视频内容享有独家版权，未经许可不得以任何形式复制、转载。
                             </div>
                             <div class="pl_btns">
                                <div class="btns1" @click="handle_dianzan">
                                    <img src="../../../assets/img/index/comments_case/zan.png" alt="">
                                    点赞
                                    <span v-if="nwe_detial.op">+1</span>
                                </div>
                                <div class="btns1" @click="handle_fx">
                                    <img src="../../../assets/img/index/comments_case/fx.png" alt="">
                                    分享
                                </div>
                             </div>
                        </div>
                    </div>
                     
                </div>
                <div class="">
                    <Classroom_new_video_detial ref="Classroom_new_video_detial"></Classroom_new_video_detial>
                </div>
            </div>
        </div>
        <comments_form_pl ref="comments_form_pl"></comments_form_pl>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'

import Classroom_new_video_detial from '@/components/law/Classroom/Classroom_new_video_detial.vue'//右边
import comments_form_pl from '@/components/comments/comments_form_pl.vue'//提交评论


export default {
    components: {
        Classroom_new_video_detial,
        comments_form_pl,
    },
    name: "homes",
    data() {
        return {
            loading:false,
            is_show:false,
            nwe_detial:{},
        }
    },
    computed: {
       
    },
    watch: {
        
    },
    created() {
        this.get_detial()
    },
    methods: {
        get_detial(){
            this.loading=true
            this.$api("lesson", {
                 id:this.$route.query.id
			}, "get").then((res) => {
                this.loading = false
                console.log('法律课堂详情',res)
                if (res.code == 1) {
                   this.nwe_detial=res.data
                   if(res.data.if_pay){
                    this.is_show=true
                   }
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_dianzan(){
            this.loading=true
            this.$api("lessonOp", {
                id:this.$route.query.id,
                op:'re_up',
			}, "post").then((res) => {
                this.loading = false
                console.log('点赞',res)
                if (res.code == 1) {
                    alertSucc('点赞成功')
                    this.get_detial()
                } else {
                    alertErr(res.msg)
                }
            }); 
        },
        handle_home(){
            this.$router.push({
                path:'/home',
            })
        },
        handle_pay(){
            this.$router.push({
                path:'/Classroom_pay',
                query:{
                    id:this.$route.query.id,
                    price:this.nwe_detial.price
                }
            })
            
        },
        handle_fx(){
            let url=window.location.href
            navigator.clipboard.writeText(url).then(function() {
                alertSucc("链接复制成功！");
            }).catch(function(err) {
                alertErr("复制失败：" + err);
            });
        },
    },

}
</script>
<style scoped lang="less">
.case_detial{
    padding-bottom: 100px;
    background-color: #F5F5F5;
    .case_detial_box{
        width: 1440px;
        margin: auto;
        .top_box{
            display: flex;
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            padding: 20px 0;

            .span1 {
                cursor: pointer;
            }

            img {
                width: 14px;
                height: 14px;
                margin-right: 10px;
            }
        }
        .detial_flex{
            display: flex;
            // align-items: center;
            justify-content: space-between;
            .inof_box{
                width: 1000px;
                .info_1{
                    // width: 1000px;
                    // height: 1429px;
                    padding: 40px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    .title_flex{
                        display: flex;
                        align-items: center;
                       
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 24px;
                        color: #333333; 
                        img{
                            margin-left: 10px;
                            width: 70px;
                            height: 25px;
                        }

                    }
                    .tage_info{
                        display: flex;
                        align-items: center; 
                        padding-top: 16px;

                        .tage_flex{
                            display: flex;
                            align-items: center;
                            .tege_title{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                            }
                            .tege_text{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                span{
                                    color: #377CFD;
                                }
                            }
                        }
                        .borders{
                            width: 0;
                            height: 15px;
                            border-left: 1px solid #999999;
                            margin: 0 20px;
                        }
                    }

                    .btns_flex{
                        display: flex;
                        align-items: center;
                        padding-top: 20px;
                        padding-bottom: 24px;
                        border-bottom: 1px solid #D9D9D9;
                        .btns1{
                            width: 134px;
                            height: 36px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            cursor: pointer;
                            img{
                                width: 14px;
                                height: 14px;
                                margin-right: 8px;
                            }
                        }
                        .btns2{
                            width: 134px;
                            height: 36px;
                            background: #FFFFFF;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #377CFD;
                            margin-left: 16px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            cursor: pointer;
                            img{
                                width: 14px;
                                height: 14px;
                                margin-right: 8px;
                            }
                        }
                    }
                    .const_box{
                        padding-top: 24px;
                        .const_flex{
                            display: flex;
                            align-items: center;
                            margin-bottom: 16px;
                            .const_title{
                                width: 100px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                            }
                            .const_text{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                            }
                        }
                        .const_const{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            padding-bottom: 40px;
                            border-bottom: 1px solid  #D9D9D9;
                        }
                        .pl_bq{
                            padding-top: 24px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;

                        }
                        .pl_btns{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding-top: 32px;
                            .btns1{
                                width: 120px;
                                height: 36px;
                                background: #FFFFFF;
                                border-radius: 18px 18px 18px 18px;
                                border: 1px solid #D7D7D7;
                                cursor: pointer;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                margin-right: 24px;
                                img{
                                    width: 14px;
                                    margin-right: 4px;
                                }
                                span{
                                    color: #377CFD;
                                    padding-left: 4px;
                                }
                            }
                        }
                        .flie_flex{
                            display: flex;
                            align-items: center;
                            padding-top: 23px;
                            .flie_img{
                                display: flex;
                                align-items: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;
                                cursor: pointer;
                                img{
                                    width:16px ;
                                    height: 14px;
                                    margin-right: 10px;
                                }
                            }
                            .flie_name{
                                margin-left: 60px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                                cursor: pointer;
                            }
                        }
                    }
                }
                .case_infos{
                    width: 1000px;
                    min-height: 490px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    margin-top: 26px;
                    padding: 25px 32px 36px 32px;
                    .case_titles{
                     
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 24px;
                        color: #333333;
                        padding-bottom: 21px;
                    }
                    .case_texts{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        line-height: 30px;
                    }
                }
                .pl_num_box{
                    width: 100%;
                    height: 50px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    justify-content: center;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 16px;
                    color: #8590A6;
                    margin-top: 20px;
                    margin-bottom: 24px;
                }
                .pl_infos{
                    width: 100%;
                    padding: 40px 40px 23px 40px ;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    margin-bottom: 25px;
                    .pl_user{
                        display: flex;
                        // align-items: center;
                        justify-content: space-between;
                        .pl_user_left{
                            display: flex;
                            align-items: center;
                            .user_img{
                                width: 64px;
                                height: 64px;
                                img{
                                    width: 64px;
                                    height: 64px;
                                    border-radius: 50%;
                                }
                            }
                            .user_info{
                                padding-left: 24px;
                                .user_name{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 24px;
                                    color: #333333;
                                }
                                .user_time{
                                    padding-top: 11px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #666666;
                                }

                            }
                        }
                        
                        .pl_user_right{
                            .user_nums{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #8590A6;
                            }
                        }
                        
                    }
                    .pl_const_box{
                        .pl_titles{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 16px;
                            color: #333333;
                            padding-top: 24px;
                        }
                        .pl_consts{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            padding-top: 15px;
                        }
                    }
                    .pl_btns{
                        display: flex;
                        align-items: center;
                        padding-top: 40px;
                        .btns1{
                            padding: 8px 23px;
                            background: rgba(55, 124, 253, 0.08);
                            border-radius: 4px 4px 4px 4px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #377CFD;
                            cursor: pointer;
                            img{
                                width: 14px;
                            }
                        }
                        .btns2{
                            margin-left: 8px;
                            width: 36px;
                            height: 36px;
                            background: rgba(55, 124, 253, 0.08);
                            border-radius: 4px 4px 4px 4px;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            img{
                                width: 14px;
                            }
                        }
                        .btns3{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;
                            margin-left: 24px;
                            cursor: pointer;
                            img{
                                width: 13px;
                                margin-right: 4px;
                            }
                        }
                    }
                    
                }
                .comment_section{
                    // width: 1000px;
                    // height: 602px;
                    padding: 23px 30px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    .title_btns{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .titles{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 18px;
                            color: #333333;
                        }
                        .btns{
                            display: flex;
                            align-items: center;
                            .btns1{
                                padding: 8px 23px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                background: #377CFD;
                                background:rgba(55, 124, 253, 0.08);
                                border-radius: 4px 4px 4px 4px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 14px;
                                color: #377CFD;

                                img{
                                    width:14px ;
                                    height: 14px;
                                    margin-right: 8px;
                                }
                            }
                            .btns2{
                                width: 36px;
                                height: 36px;
                                background:rgba(55, 124, 253, 0.08);
                                border-radius: 4px 4px 4px 4px;
                                margin-left: 8px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                img{
                                    width:14px ;
                                    height: 14px;
                                }
                            }
                            .btns3{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                text-align: center;
                                margin-left: 24px;
                                cursor: pointer;
                                img{
                                    width:13px ;
                                    // height: 12px;
                                    // margin-right: 8px;
                                }

                            }
                        }
                    }
                    .comment_list{
                        padding-top: 24px;
                        .items{
                            width: 940px;
                            min-height: 220px;
                            background: #FFFFFF;
                            border-radius: 3px 3px 3px 3px;
                            border: 1px solid #D7DEE5;
                            margin-bottom: 17px;
                            padding: 21px 29px 30px 25px;
                            .items_top{
                                display: flex;
                                .user_imgs{
                                    width: 64px;
                                    height: 64px;
                                    img{
                                        width: 64px;
                                        height: 64px;
                                        border-radius: 50%;
                                    }
                                }
                                .user_info{
                                    width: 200px;
                                    padding:  8px 0;
                                    padding-left: 24px;
                                    display: flex;
                                    flex-wrap: wrap;
                                    align-content: space-between;
                                    .names{
                                        width: 100%;
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 14px;
                                        color: #666666;

                                    }
                                    .times{
                                        width: 100%;
                                       
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 12px;
                                        color: #666666;

                                    }
                                }
                                .comment_num{
                                    .num_flex{
                                        display: flex;
                                        align-items: center;
                                        .nums{
                                            img{
                                                width: 21px;
                                                height: 20px;
                                            }
                                        }
                                    }
                                    .comment_text{
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 14px;
                                        color: #333333;
                                        padding-top: 20px;
                                    }
                                }
                            }
                            .items_bom{
                                // width: 886px;
                                min-height: 78px;
                                background: #F5F5F5;
                                border-radius: 4px 4px 4px 4px;
                                margin-top: 27px;

                                padding:18px 52px 16px 22px ;
                            
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;

                            }
                        }
                        .comment_num_btns{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            span{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #8590A6;
                                cursor: pointer;
                            }

                        }
                    }
                }
                .comprehensive_reviews{
                    width: 1000px;
                    min-height: 194px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    margin-top: 20px;
                    padding: 13px 52px 10px 28px;
                    .review_title{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;

                    }
                    .review_text{
                        padding-top: 24px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                        line-height: 30px;
                    }
                }
                .announcement_box{
                    width: 1000px;
                    min-height: 271px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    padding: 13px 52px 14px 28px;
                    margin-top: 16px;
                    .announcement_title{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;
                        text-align: center;

                    }
                    .announcement_text{
                        padding-top: 24px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                        line-height: 32px;
                    }
                }
            }
            .inof_box_show{
                // width: 100%;
                position: relative;
                height: 1270px;
                overflow: hidden;
                background-color: #FFFFFF;
                .info_pay_btns{
                    width: 100%;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    .info_pay_btns_top{
                        width: 100%;
                        height: 118px;
                        background: linear-gradient( 180deg, rgba(255,255,255,0) 0%, #FFFFFF 100%);
                        border-radius: 0px 0px 0px 0px;
                    }
                    .info_pay_btns_bom{
                        width: 100%;
                        height: 769px;
                        background: #FFFFFF;
                        border-radius: 0px 0px 0px 0px;
                        display: flex;
                        justify-content: center;
                        padding-top: 10px;
                        .btns_pay{
                            width: 134px;
                            height: 36px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px;
                            text-align: center;
                            line-height: 36px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            cursor: pointer;
                        }
                    }
                   
                   
                   
                }
            }
        }
    }
}

</style>